import { produce } from 'immer';
import { useCallback, useState } from 'react';

interface IReturn {
    objState: any;
    setObjState?: React.Dispatch<any>;
    handleObjState: (path: string, value: any) => void;
}
function useObjectState({
    initialValue = {},
    notNeedSetState = true
}: {
    initialValue: any;
    notNeedSetState?: boolean;
}): IReturn {
    const [objState, setObjState] = useState(initialValue);
    const handleObjState = useCallback(
        (path, value) =>
            setObjState(
                produce((draft) => {
                    _.set(draft, path, value);
                })
            ),
        []
    );
    if (notNeedSetState) return { objState, handleObjState };
    return { objState, setObjState, handleObjState };
}

export default useObjectState;
